import { useState, useEffect } from 'react';

// Este custom hook devuelve `true` si el ancho de la pantalla es menor a 768px.
// Si el entorno no soporta matchMedia (ej. tests con jsdom) devuelve `false`.
const supportsMatchMedia = () => typeof window !== 'undefined' && typeof window.matchMedia === 'function';

export const useMediaQuery = (query = '(max-width: 768px)') => {
  const [matches, setMatches] = useState(() => supportsMatchMedia() && window.matchMedia(query).matches);

  useEffect(() => {
    if (!supportsMatchMedia()) return undefined;
    const mediaQueryList = window.matchMedia(query);
    setMatches(mediaQueryList.matches);
    const listener = (event) => setMatches(event.matches);

    // Añade el listener para cambios de tamaño de pantalla
    mediaQueryList.addEventListener('change', listener);

    // Limpia el listener cuando el componente se desmonta
    return () => mediaQueryList.removeEventListener('change', listener);
  }, [query]);

  return matches;
};
